/** Treatment endings — dropout / discharge (ZOY-723 / ZOY-724). */
export const treatmentEn: Record<string, string> = {
  'te.action': 'End treatment',
  'te.dialog.title': 'Record the end of treatment',
  'te.dialog.sub':
    'Record a dropout or a discharge. Future appointments are cancelled and packages are stopped.',
  'te.kind.label': 'Kind',
  'te.kind.dropout': 'Dropout',
  'te.kind.discharge': 'Discharge',
  'te.scope.label': 'Scope',
  'te.scope.patient': 'Whole treatment',
  'te.scope.service': 'One service',
  'te.scope.package': 'One package',
  'te.package': 'Package',
  'te.service': 'Service',
  'te.choose': 'Choose',
  'te.reason': 'Reason for dropping out',
  'te.reason.cost': 'Cost',
  'te.reason.distance_or_time': 'Distance or time',
  'te.reason.no_visible_progress': 'No visible progress',
  'te.reason.dissatisfied_with_therapist': 'Dissatisfied with the therapist',
  'te.reason.moved_to_another_centre': 'Moved to another centre',
  'te.reason.relocation': 'Relocation',
  'te.reason.child_illness': "Child's illness",
  'te.reason.family_circumstances': 'Family circumstances',
  'te.reason.other': 'Other',
  'te.decidedBy.label': 'Decided by',
  'te.decidedBy.family': 'Family',
  'te.decidedBy.clinic': 'Clinic',
  'te.note': 'Note',
  'te.preview.title': 'What recording this does',
  'te.preview.bookings': 'Future appointments that are cancelled: {n}',
  'te.preview.packages': 'Packages that are stopped: {names}',
  'te.preview.noPackages': 'No package is stopped.',
  'te.preview.settled': 'The account is settled; this becomes final right away.',
  'te.preview.unsettled':
    'The account is not settled (debt {debt}, credit {credit}). It stays pending until it is.',
  'te.confirm': 'Record',
  'te.cancel': 'Cancel',
  'te.notCancelled': '{n} appointments could not be cancelled and need a manual check.',
  'te.pending.title': 'End of treatment — waiting for settlement',
  'te.pending.body': '{what} is recorded but not final yet. Settle the account first.',
  'te.pending.debt': 'Patient owes: {amount}',
  'te.pending.credit': 'Credit held by the clinic: {amount}',
  'te.pending.settled': 'The account is settled; you can finalize.',
  'te.pending.goPayments': 'Payments and refund',
  'te.finalize': 'Finalize',
  'te.withdraw': 'Withdraw this record',
  'te.withdraw.title': 'Withdraw this record?',
  'te.withdraw.body': 'Stopped packages re-open. Cancelled appointments do not come back.',
  'te.final.dropout': 'Dropped out',
  'te.final.discharge': 'Discharged',
  'te.final.reason': 'Reason: {reason}',
  'te.return': 'Patient returned',
  'te.return.title': 'The patient is back',
  'te.return.body': 'How should treatment continue?',
  'te.return.resume': 'Continue the unfinished package',
  'te.return.resumeHelp': 'Stopped packages re-open and booking continues.',
  'te.return.new': 'New assessment and a new package',
  'te.return.newHelp': 'The earlier packages stay stopped and you go on to a reassessment.',
  'te.scopeLabel.patient': 'Whole treatment',
  'te.scopeLabel.service': 'Service {name}',
  'te.scopeLabel.package': 'Package {name}',
  'te.err.notSettled': 'The account is not settled yet.',
  'te.err.alreadyOpen': 'An end of treatment is already recorded for this scope.',
  'te.err.generic': 'That did not work. Please try again.',
  'te.cancelReason.dropout': 'Dropout — {reason}',
  'te.cancelReason.discharge': 'Discharge',
  'te.stopped': 'Stopped',

  'py.refund.title': 'Refund to the patient',
  'py.refund.sub': 'Return credit the clinic is holding for this patient.',
  'py.refund.amount': 'Refund amount',
  'py.refund.amountHelp': 'At most {max}',
  'py.refund.from': 'From which credit',
  'py.refund.fromAny': 'General credit, then packages',
  'py.refund.cta': 'Record refund',
  'py.refund.done': 'Refund recorded.',
  'py.refund.errExceeds': 'More than the available credit (available: {max}).',
  'py.refund.histTitle': 'Recorded refunds',
  'py.hist.errRefunded': 'Part of this payment was refunded, so it can no longer be reversed.',

  'te.cr.tab': 'Continuation',
  'te.cr.sub':
    'Courses whose last session was 14 or more days ago and whose patient took no next step.',
  'te.cr.col.patient': 'Patient',
  'te.cr.col.package': 'Course',
  'te.cr.col.last': 'Last session',
  'te.cr.col.days': 'Days since',
  'te.cr.col.therapist': 'Therapist',
  'te.cr.col.progress': 'Sessions',
  'te.cr.col.outcome': 'Outcome',
  'te.cr.continuing': 'Continuing',
  'te.cr.emptyTitle': 'Nothing to follow up',
  'te.cr.emptyBody': 'A finished course with no next step appears here after 14 days.',
  'te.cr.again': '"Continuing" was recorded before',
  'te.cr.ofPlanned': '{delivered} of {planned}',
};
